import { Controller } from "@hotwired/stimulus"

// The giver's claim-a-wish check. The row holds a small form posting to
// buy_wish_path; this controller asks for quantity when more than one is left
// before submitting.
//
//   %form{data: { controller: "buy", buy_left_value: 3 }}
//     %input{type: :hidden, name: "wish[bought]", value: "1"}
//     %input{type: :hidden, name: "wish[amount_bought]", value: "1", data: { buy_target: "amount" }}
//     %button.check{data: { action: "buy#claim" }}
export default class extends Controller {
  static targets = ["amount"]
  static values = { left: Number }

  claim(event) {
    event.preventDefault()
    if (this.hasAmountTarget && this.leftValue > 1) {
      const input = window.prompt(`Antall (1–${this.leftValue}):`, "1")
      if (input === null) return
      const amount = Math.min(Math.max(parseInt(input, 10) || 1, 1), this.leftValue)
      this.amountTarget.value = amount
    }
    this.element.requestSubmit()
  }
}
